import React, { useState, useEffect } from 'react'
import { Select, Icon } from 'antd'
import { TenantService } from '../../connection/TenantService'
import { Tenant } from 'connection/models/Tenant'

interface TenantSelectProps {
  onSelectTenant: Function;
}

export function TenantSelect({ onSelectTenant }: TenantSelectProps) {
  const [tenants, setTenants] = useState<Tenant[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [currentTenant, setCurrentTenant] = useState<Tenant>(null)

  useEffect(() => {
    function getSelectedTenant(tenantsSettings: Tenant[]) {
      const tenant = TenantService.getSelectedTenant()
      if (tenant)
        return tenant

      const firstTenantDefault = tenantsSettings[0]
      onSelectTenant(firstTenantDefault)

      return firstTenantDefault
    }

    async function getTenants() {

      const tenantsSettings = await TenantService.getTenants()
      setTenants(tenantsSettings)

      const tenant = getSelectedTenant(tenantsSettings)
      setCurrentTenant(tenant)
      setIsLoading(false)
    }
    getTenants()
  }, [])

  function handleSelectTenant(value: string) {
    const tenantByName = tenants.find(t => t.name === value)
    setCurrentTenant(tenantByName)
    onSelectTenant(tenantByName)
  }

  return (
    <div className="tenant-selector">
      <Icon type='cluster' className="cluster-icon" />
      <Select
        loading={isLoading}
        style={{ width: 200 }}
        onSelect={handleSelectTenant}
        value={currentTenant ? currentTenant.name : ''}>
        {tenants.map(tenant => (
          <Select.Option
            key={tenant.name}
            value={tenant.name}
          >
            {tenant.name}
          </Select.Option>
        ))}
      </Select>
    </div>)
}
